import { CheckCircle2 } from "lucide-react";

export default function WhyUs({ t }) {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="bg-white border-b border-[#e2e6ec]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* Left: image bento — real photos of Selena Service */}
          <div className="lg:col-span-5 grid grid-cols-2 gap-3">
            <div
              data-testid="why-image-1"
              className="col-span-2 aspect-[16/9] bg-cover bg-center border border-[#e2e6ec]"
              style={{
                backgroundImage: "url('/resources/selena-fatada-side.jpg')",
              }}
            />
            <div
              data-testid="why-image-2"
              className="aspect-square bg-cover bg-center border border-[#e2e6ec]"
              style={{
                backgroundImage: "url('/resources/selena-mecanica.jpg')",
              }}
            />
            <div
              data-testid="why-image-3"
              className="aspect-square bg-cover bg-center border border-[#e2e6ec]"
              style={{
                backgroundImage: "url('/resources/selena-itp-camioane.jpg')",
              }}
            />
          </div>

          {/* Right: content */}
          <div className="lg:col-span-7 lg:pl-8">
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#e3191b] mb-4">
              {t.why.eyebrow}
            </div>
            <h2 className="font-[Barlow_Condensed] font-bold uppercase tracking-tight text-[#0b1220] text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              {t.why.title}
            </h2>
            <p className="mt-6 text-slate-600 leading-relaxed max-w-xl">
              {t.why.lead}
            </p>

            <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
              {t.why.bullets.map((b, i) => (
                <li
                  key={i}
                  data-testid={`why-bullet-${i}`}
                  className="flex items-start gap-3 text-sm text-slate-700"
                >
                  <CheckCircle2
                    className="w-5 h-5 text-[#0b378c] flex-shrink-0 mt-0.5"
                    strokeWidth={2}
                  />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
